export { default as TextH1 } from "./TextH1";
export { default as TextH2 } from "./TextH2";
export { default as TextVerify } from "./TextVerify";
export { default as Text } from "./Text";
export { default as TextLink } from "./TextLink";
